/* eslint-disable @typescript-eslint/naming-convention */
export const PAGES = {
  LOG_IN: 'login',
  CREATE_LOAD: 'create-load',
  LIST_LOADS: 'list-loads',
  LIST_BOOKINGS: 'list',
  BOOKINGS: 'bookings',
  CONFIRMED_BOOKINGS: 'confirmation',
  APP: 'app',
};
